@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;
$var-report-type-list-min-height: 300px;
$var-report-type-list-small-text: 12px;

.container {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;
}

.job-report-type {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: Constants.$val-spacing-m;
	padding-top: Constants.$val-spacing-l;
}

.filter-container {
	display: flex;

	& > div {
		width: 100%;
	}
}

.filter {
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	display: flex;
	align-items: center;
	background: Colors.$col-white;
}

.date-filter {
	display: flex;
}

.number-of-rows-selected {
	font-style: italic;
	color: Colors.$col-greyInactive;
}

.group-actions {
	display: flex;
	gap: Constants.$val-spacing-l;

	& > span {
		color: Colors.$col-blue;
		cursor: pointer;

		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}
}

.customer-fields {
	display: flex;
	gap: Constants.$val-spacing-m;
}

.customer-fields-hint {
	color: Colors.$col-greyFontLight;
	font-style: italic;
}

.report-type-list {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	max-height: $var-report-type-list-min-height;
	overflow: auto;

	&--empty {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: Constants.$val-spacing-l;
		color: Colors.$col-greyFontLight;
		font-style: italic;
	}

	&--non-selected {
		padding: Constants.$val-spacing-l;
		display: flex;
		font-style: italic;
		justify-content: center;
		align-items: center;
		height: 100%;
	}
}

.report-type-row {
	display: grid;
	grid-template-columns: 30px 2fr 3fr 2fr 2fr;
	gap: Constants.$val-spacing-xs;

	&__small-text {
		font-size: $var-report-type-list-small-text;
	}
}
